var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RemovableCard } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { createRef, PureComponent } from 'react';
import RichTextField from 'components/shared/util/richTextField/containers/richTextField';
import styles from '../bulkActionsModal.module.scss';
const STATE_UPDATE_THROTTLE = 300;
export class BulkActionsAddInternalNote extends PureComponent {
    constructor(props) {
        super(props);
        this.editorRef = createRef();
        this.timeout = null;
    }
    handleRemove() {
        this.props.setNote('');
        this.props.onRemove();
    }
    handleChange() {
        const { current } = this.editorRef;
        if (!current) {
            return;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        // in order to increase performance
        this.timeout = setTimeout(() => {
            this.props.setNote(current.getText());
        }, STATE_UPDATE_THROTTLE);
    }
    renderTemplate({ content }) {
        return Promise.resolve({ data: { rendered_content: content } });
    }
    componentDidMount() {
        if (this.editorRef.current) {
            this.editorRef.current.focus();
        }
    }
    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    render() {
        const hasFFWriteHTMLEmail = { hasFFWriteHTMLEmail: true };
        return (_jsx(RemovableCard, Object.assign({ className: styles.actionCard, icon: "sticky-note", title: "Add internal note", onRemove: this.handleRemove }, { children: _jsx("div", Object.assign({ className: classnames(styles.textEditorContainer, styles.actionInternalNoteContainer) }, { children: _jsx(RichTextField
                // NOTE: Do it like this because there's something wrong with the typing.
                , Object.assign({}, hasFFWriteHTMLEmail, { ref: this.editorRef, className: styles.textEditor, renderTemplate: this.renderTemplate, channel: "bulk", placeholder: "Type your internal note...", onChange: this.handleChange })) })) })));
    }
}
__decorate([
    boundMethod
], BulkActionsAddInternalNote.prototype, "handleRemove", null);
__decorate([
    boundMethod
], BulkActionsAddInternalNote.prototype, "handleChange", null);
__decorate([
    boundMethod
], BulkActionsAddInternalNote.prototype, "renderTemplate", null);
